import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_next",
  "use": "icon-icon_next-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-icon_next\"><path d=\"M19.06 33.667a1.5 1.5 0 0 1-2.12-2.121L26.484 22l-9.546-9.546a1.5 1.5 0 0 1 2.122-2.121l10.606 10.606a1.5 1.5 0 0 1 .098 2.015l-.098.107-10.606 10.606Z\" fill=\"#FFF\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol